import React from 'react';
import PropTypes from 'prop-types';

function Body({ color }) {
  return (
    <path
      d="M709.527 441.575C714.994 437.408 719.751 426.221 723.645 413.29C722.007 382.808 715.262 342.474 706.108 291.313C688.489 192.868 655.76 136.79 644.314 123.434C632.867 110.08 615.742 112.774 605.435 110.485C595.133 108.196 558.588 118.546 548.286 121.98C537.984 125.414 507.248 122.075 507.248 122.075L398.139 123.151L288.9 122.075C288.9 122.075 258.088 125.414 247.785 121.98C237.483 118.546 200.9 108.196 190.598 110.485C180.295 112.774 163.149 110.08 151.702 123.434C140.255 136.79 107.52 192.868 89.8994 291.313C80.8272 342.002 74.1194 382.067 72.4027 412.448C76.3437 425.733 81.1875 437.318 86.7741 441.575C102.801 453.785 134.855 466.759 175.303 465.996C187.555 465.765 198.256 464.27 207.235 462.303C220.678 422.919 228.269 376.558 238.722 370.286C250.169 363.418 249.616 362.014 253.146 362.777C256.676 363.541 270.699 374.988 287.68 375.465C304.661 375.942 318.017 373.366 325.076 368.883C332.136 364.399 336.475 358.484 338.097 358.389C338.934 358.34 359.861 358.341 379.546 358.354V358.389C379.546 358.389 387.403 358.379 397.983 358.369C408.583 358.379 416.455 358.389 416.455 358.389V358.354C436.14 358.341 457.066 358.34 457.902 358.389C459.524 358.484 463.862 364.399 470.92 368.883C477.979 373.366 491.336 375.942 508.314 375.465C525.296 374.988 539.322 363.541 542.851 362.777C546.381 362.014 545.827 363.418 557.273 370.286C567.723 376.554 575.313 422.864 588.738 462.233C597.785 464.235 608.595 465.762 620.997 465.996C661.444 466.759 693.499 453.785 709.527 441.575Z"
      fill={color}
    />
  );
}

Body.propTypes = {
  color: PropTypes.string,
};

Body.defaultProps = {
  color: '#24282B',
};

export default Body;
